export default __webpack_public_path__ + "static/media/novalogovr.0be0f72e.png";